import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    return (
        <nav className="fixed w-full bg-white/90 backdrop-blur-md shadow-sm z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <Link to="/" className="flex items-center space-x-2">
                        <img 
                            src="/assets/Payrendr.png" 
                            alt="Payrendr Logo" 
                            className="h-8 w-auto"  
                        />
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center space-x-6">
                        <div className="relative group">
                            <button
                                className="flex items-center text-gray-700 hover:text-primary-600 transition-colors duration-300 group"
                                onMouseEnter={() => setActiveDropdown('solutions')}
                                onMouseLeave={() => setActiveDropdown(null)}
                            >
                                <span className="font-medium">Solutions</span>
                                <ChevronDown className="h-4 w-4 ml-1 group-hover:rotate-180 transition-transform" />
                            </button>

                            {activeDropdown === 'solutions' && (
                                <div 
                                    className="absolute left-0 mt-4 w-80 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden"
                                    onMouseEnter={() => setActiveDropdown('solutions')}
                                    onMouseLeave={() => setActiveDropdown(null)}
                                >
                                    <Link
                                        to="/financial"
                                        className="block px-5 py-4 hover:bg-gray-50 transition-colors group"
                                    >
                                        <div className="flex items-center">
                                            <div className="flex-grow">
                                                <p className="text-sm font-semibold text-gray-900 group-hover:text-primary-600">
                                                    Financial Management
                                                </p>
                                                <p className="text-xs text-gray-500 mt-1">
                                                    Complete accounting and financial tools
                                                </p>
                                            </div>
                                            <ChevronDown className="h-4 w-4 text-gray-400 group-hover:text-primary-600 transform rotate-[-90deg]" />
                                        </div>
                                    </Link>
                                </div>
                            )}
                        </div>

                        <Link 
                            to="/about" 
                            className="text-gray-700 hover:text-primary-600 font-medium transition-colors"
                        >
                            About
                        </Link>
                        <Link 
                            to="/dashboard" 
                            className="text-gray-700 hover:text-primary-600 font-medium transition-colors"
                        >
                            Dashboard
                        </Link>
                    </div>

                    {/* CTA Buttons */}
                    <div className="hidden md:flex items-center space-x-4">
                        <Link to="/login">
                            <button className="text-gray-600 hover:text-primary-600">
                                Log in
                            </button>
                        </Link>
                        <button className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors">
                            Start Free Trial
                        </button>
                    </div>

                    {/* Mobile Menu Toggle */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-gray-700 hover:text-primary-600 transition-colors"
                        >
                            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden bg-white shadow-md">
                    <div className="px-4 pt-2 pb-4 space-y-2">
                        <div className="relative group mb-2">
                            <button 
                                className="w-full flex justify-between items-center px-3 py-2 text-gray-700 hover:bg-gray-50 rounded-md"
                                onClick={() => setActiveDropdown(activeDropdown === 'solutions' ? null : 'solutions')}
                            >
                                <span>Solutions</span>
                                <ChevronDown 
                                    className={`h-4 w-4 transition-transform ${
                                        activeDropdown === 'solutions' ? 'rotate-180' : ''
                                    }`} 
                                />
                            </button>

                            {activeDropdown === 'solutions' && (
                                <div className="ml-4 mt-2 space-y-2">
                                    <Link
                                        to="/financial"
                                        className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
                                        onClick={() => setIsOpen(false)}
                                    >
                                        Financial Management
                                    </Link>
                                </div>
                            )}
                        </div>

                        <Link
                            to="/about"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-50 rounded-md"
                            onClick={() => setIsOpen(false)}
                        >
                            About
                        </Link>
                        <Link
                            to="/dashboard"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-50 rounded-md"
                            onClick={() => setIsOpen(false)}
                        >
                            Dashboard
                        </Link>

                        <div className="pt-4 space-y-2">
                            <Link 
                                to="/login" 
                                onClick={() => setIsOpen(false)}
                                className="block"
                            >
                                <button className="w-full px-3 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                                    Log In
                                </button>
                            </Link>

                            <button className="w-full px-3 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">
                                Start Free Trial
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;